var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    d: "M10.814,24.987a.552.552,0,0,1-.391-.952l3.209-3.048L10.423,17.94a.557.557,0,0,1-.014-.786.573.573,0,0,1,.8-.014l3.628,3.448a.561.561,0,0,1,0,.8L11.2,24.836A.6.6,0,0,1,10.814,24.987Zm-3.223-.165a.557.557,0,0,0-.014-.786L4.367,20.988,7.577,17.94a.557.557,0,0,0,.014-.786.573.573,0,0,0-.8-.014L3.167,20.588a.561.561,0,0,0,0,.8L6.8,24.836a.6.6,0,0,0,.391.152A.586.586,0,0,0,7.591,24.822Z",
    transform: "translate(-3 -16.987)",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.1c7e98860b52854799657ac3bb86522e.svg";
export { ForwardRef as ReactComponent };